import type { IParticipationResult } from '../../../models/pa-egna-ben/participation-result.js';
import LegResultApiModel from './leg-result.api-model.js';
import { LegApiModel } from './leg.api-model.ts.js';

export default class ParticipationResultApiModel {
  public weightedTotalScore!: number;
  public rank!: number;
  public numberOfStudents!: number;
  public noOfMunicipalityParticipations!: number;
  public participationName!: string;
  public municipalityName!: string;
  public municipalityGid!: string;
  public carbonDioxide!: number;
  public completedKilometers!: number;
  public legs!: LegApiModel[];
  public legResults!: LegResultApiModel[];

  static mapToBusinessModel(apiModel: ParticipationResultApiModel): IParticipationResult {
    return {
      weightedTotalScore: apiModel.weightedTotalScore,
      rank: apiModel.rank,
      numberOfStudents: apiModel.numberOfStudents,
      noOfMunicipalityParticipations: apiModel.noOfMunicipalityParticipations,
      participationName: apiModel.participationName,
      municipalityName: apiModel.municipalityName,
      municipalityGid: apiModel.municipalityGid,
      carbonDioxide: apiModel.carbonDioxide,
      completedKilometers: apiModel.completedKilometers,
      legs: apiModel.legs?.map(LegApiModel.mapToBusinessModel),
      legResults: apiModel.legResults,
    };
  }
}

